import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import rent from '@/components/rent'
import around from '@/components/around'
import map from '@/components/townMap'
import contact from '@/components/contact'
import company from '@/components/company'
import location from '@/components/location'
import base from '@/components/base'
import resume from '@/components/resume'
import funtime from '../components/funTime'
import position from '../components/position'
import communityDetail from '../components/communityDetail'
import notice from '../components/notice'
import protocol from '../components/protocol'
import aboutProtocol from '../components/aboutProtocol'
import featureIntro from '../components/featureIntro'
import specialInstructions from '../components/specialInstructions'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  // base: '/community/hybridH5/',
  routes: [
    {
      path: '*',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/rent',
      name: '租房详情',
      component: rent
    },
    {
      path: '/around',
      name: '周边楼盘',
      component: around
    },
    {
      path: '/communityDetail',
      name: '项目介绍',
      component: communityDetail
    },
    {
      path: '/map',
      name: '小镇地图',
      component: map
    },
    {
      path: '/base',
      name: '园区基本情况',
      component: base
    },
    {
      path: '/contact',
      name: '联系我们',
      component: contact
    },
    {
      path: '/company',
      name: '入驻企业',
      component: company
    },
    {
      path: '/location',
      name: '园区位置',
      component: location
    },
    {
      path: '/resume',
      name: '投递简历',
      component: resume
    },
    {
      path: '/funtime',
      name: '轻松一刻',
      component: funtime
    },
    {
      path: '/position',
      name: '职位详情',
      component: position
    },
    {
      path: '/notice',
      name: '通知详情',
      component: notice
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: protocol
    },
    {
      path: '/aboutProtocol',
      name: 'aboutProtocol',
      component: aboutProtocol
    },
    {
      path: '/featureIntro',
      name: 'featureIntro',
      component: featureIntro
    },
    {
      path: '/specialInstructions',
      name: 'specialInstructions',
      component: specialInstructions
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js